module.exports = __webpack_public_path__ + "img/lnb_02.082c1f59.png";